<app-share-button></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
<div class="card crd p-3">
    <div class="row">
        <div class="col-md-10 col10 mt-2">
            <h2 >पेमेंट गेटवे उद्योग की कार्यप्रणाली</h2>
        </div>
        <div class="col-md-2 col2 ">
            <a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a> 
                </div> 

                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="5">
                    <div style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/fiAnbtH16Kw?si=vaIlO3JntZcLPgVv" 
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div>
                   
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')"
        (mouseout)="showpayment(false,'2')" id="120"  >
           <h3>पेमेंट एग्रीगेटर क्या हैं?</h3>
           <P>पेमेंट एग्रीगेटर ऐसी संस्थाएं हैं जो व्यापारियों और ग्राहकों के बीच ऑनलाइन लेनदेन की सुविधा प्रदान करती हैं। वे एक ही व्यापारी खाते या समझौते के तहत कई व्यापारियों को समेकित करते हैं, जिससे इन व्यापारियों को भुगतान प्रोसेसर या बैंकों के साथ अपने स्वयं के व्यापारी खाते स्थापित करने की आवश्यकता के बिना भुगतान स्वीकार करने की अनुमति मिलती है।</P>
        </div>
        
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'5')"
        (mouseout)="showpayment(false,'5')" id="121">
           <h3>खिलाड़ियों को समझना </h3>
           <h3>पूरी प्रक्रिया में मुख्य रूप से चार मुख्य खिलाड़ी शामिल हैं:</h3>
        
        <div class="col-md-12 mt-3">
            <Label class="mt-4 spn" > <b>व्यापारी: </b> &nbsp; ये वे व्यवसाय हैं जो सामान या सेवाएँ ऑनलाइन बेचते हैं।</Label>
            <Label class="mt-4 spn" > <b>ग्राहक: </b> &nbsp;ये वे व्यक्ति हैं जो व्यापारियों से उत्पाद या सेवाएँ खरीदते हैं। </Label>
            <Label class="mt-4 spn" > <b>भुगतान गेटवे/एग्रीगेटर:</b> &nbsp;ये सेवा प्रदाता हैं जो व्यापारियों और वित्तीय संस्थानों के बीच ऑनलाइन लेनदेन की सुविधा प्रदान करते हैं। वे भुगतान प्रसंस्करण के तकनीकी पहलुओं को सुरक्षित रूप से संभालते हैं।</Label>
            <Label class="mt-4 spn" > <b>अधिग्रहणकर्ता: </b> &nbsp;ये वित्तीय संस्थान (जैसे बैंक) हैं जिनके पास लेनदेन को संसाधित करने के लिए समझौते हैं।</Label>
         </div>
         </div>
         <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'3')"
         (mouseout)="showpayment(false,'3')" id="122">
            <label for="" class="spm" >आइए इस प्रक्रिया को सरल बनाएं कि पेमेंट एग्रीगेटर/पेमेंट गेटवे उद्योग कैसे काम करता है, PayG पर ध्यान केंद्रित करें जो विशेष रूप से व्यापारियों से संबंधित है।</label>
         <div class="col-md-12 mt-3">
            <h3 class="mt-4 spn"> Let’s understand the process:</h3>
            <Label class="mt-4 spn" > <b>चरण 1: व्यापारी एकीकरण: </b> <br>व्यापारी पेमेंट गेटवे/एग्रीगेटर कंपनी के साथ साइन अप करते हैं। इसमें एक खाता बनाना और आवश्यक व्यावसायिक जानकारी प्रदान करना शामिल है। भुगतान गेटवे एकीकरण उपकरण प्रदान करता है जो व्यापारियों को अपनी वेबसाइटों या ऐप्स में भुगतान प्रसंस्करण को आसानी से शामिल करने की अनुमति देता है।</Label>
            <Label class="mt-4 spn" > <b>चरण 2: ग्राहक चेकआउट:</b> <br>जब कोई ग्राहक खरीदारी करने का निर्णय लेता है, तो वे व्यापारी की वेबसाइट या ऐप पर चेकआउट प्रक्रिया से गुजरते हैं। चेकआउट के समय, ग्राहक अपनी भुगतान जानकारी, जैसे क्रेडिट कार्ड विवरण, दर्ज करता है। </Label>
            <Label class="mt-4 spn" > <b>चरण 3: लेनदेन एन्क्रिप्शन:</b> <br>भुगतान गेटवे ग्राहक की भुगतान जानकारी को एन्क्रिप्ट करता है ताकि यह सुनिश्चित हो सके कि यह इंटरनेट पर सुरक्षित रूप से प्रसारित हो।</Label>
            <Label class="mt-4 spn" > <b>चरण 4: प्राधिकरण अनुरोध:</b> <br>भुगतान गेटवे ग्राहक की भुगतान विधि (जैसे, वीज़ा, मास्टरकार्ड) से जुड़े अधिग्रहणकर्ता को एक प्राधिकरण अनुरोध भेजता है।</Label>
            <Label class="mt-4 spn" > <b>चरण 5: प्राधिकरण प्रक्रिया:</b> <br>अधिग्रहणकर्ता प्राधिकरण अनुरोध प्राप्त करता है और इसे उपयुक्त कार्ड नेटवर्क (जैसे, वीज़ा, मास्टरकार्ड) को अग्रेषित करता है। कार्ड नेटवर्क भुगतान विवरण और खाते की शेष राशि को सत्यापित करने के लिए ग्राहक के बैंक तक अनुरोध भेजता है।</Label>
            <Label class="mt-4 spn" > <b>चरण 6: लेन-देन अनुमोदन:</b> <br>यदि ग्राहक का बैंक लेनदेन को मंजूरी देता है, तो एक प्राधिकरण कोड उत्पन्न होता है और उसी चैनल के माध्यम से वापस भेजा जाता है। अधिग्रहणकर्ता प्राधिकरण कोड प्राप्त करता है और इसे भुगतान गेटवे पर भेजता है। </Label>
            <Label class="mt-4 spn" > <b>चरण 7: व्यापारी को सूचना:</b> <br> भुगतान गेटवे व्यापारी को सूचित करता है कि लेनदेन अधिकृत हो गया है, जिससे उन्हें ऑर्डर पूरा करने के लिए आगे बढ़ने की अनुमति मिलती है। </Label>
            <Label class="mt-4 spn" > <b>चरण 8: निधि निपटान:</b> <br> लेन-देन अधिकृत होने के बाद, भुगतान गेटवे ग्राहक के बैंक से व्यापारी के बैंक खाते में धनराशि स्थानांतरित करने की प्रक्रिया शुरू करता है। इस निपटान प्रक्रिया को पूरा होने में आम तौर पर कुछ व्यावसायिक दिन लगते हैं।</Label>
            <Label class="mt-4 spn" > <b>चरण 9: लेन-देन रिपोर्टिंग और प्रबंधन:</b> <br>भुगतान गेटवे व्यापारियों को लेनदेन को ट्रैक करने और प्रबंधित करने के लिए उपकरण प्रदान करता है, जिसमें बिक्री डेटा और राजस्व विश्लेषण के लिए रिपोर्टिंग सुविधाएं शामिल हैं। </Label>
            <Label class="mt-4 spn" > <b>चरण 10: फीस और शुल्क:</b> <br>भुगतान गेटवे/एग्रीगेटर संसाधित प्रत्येक लेनदेन के लिए व्यापारियों से शुल्क लेते हैं। यह शुल्क लेनदेन की मात्रा और प्रदान की गई सेवाओं जैसे कारकों के आधार पर भिन्न होता है। अधिग्रहणकर्ता लेन-देन के प्रसंस्करण के लिए व्यापारियों से शुल्क भी ले सकते हैं, जिसमें इंटरचेंज शुल्क (कार्ड नेटवर्क को भुगतान) और अधिग्रहणकर्ता शुल्क शामिल हो सकते हैं। </Label>
            <Label class="mt-1 spn" > <br>संक्षेप में, भुगतान गेटवे/एग्रीगेटर उद्योग व्यापारियों, ग्राहकों और वित्तीय संस्थानों के बीच सुरक्षित ऑनलाइन लेनदेन की सुविधा प्रदान करके काम करता है। सुचारु और कुशल भुगतान प्रसंस्करण सुनिश्चित करने के लिए भुगतान गेटवे के सहयोग से काम करते हुए, अधिग्रहणकर्ता व्यापारियों की ओर से लेनदेन के प्रसंस्करण में महत्वपूर्ण भूमिका निभाते हैं।</Label>
            
        </div>
        </div>

        
        <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'4')"
            (mouseout)="showpayment(false,'4')" id="123">
           <h3> पेमेंट गेटवे और पेमेंट एग्रीगेटर्स के बीच मुख्य अंतर </h3> 
            <Label class="mt-1 spn" > <br>पेमेंट गेटवे और पेमेंट एग्रीगेटर्स के बीच मुख्य अंतर ऑनलाइन लेनदेन और उनके लक्षित ग्राहकों को सुविधाजनक बनाने के उनके दृष्टिकोण में निहित है:</Label>
           <table class="table">
            <tr>
            <th class="tabled">क्र.सं.</th>
            <th class="tabled">भुगतान गेटवे</th>
            <th class="tabled">भुगतान एग्रीगेटर</th>
           </tr>
           <tr class="tabled">
            <td class="tabled">1.</td>
            <td class="tabled">भुगतान गेटवे मुख्य रूप से सुरक्षित लेनदेन प्रसंस्करण और डेटा अखंडता सुनिश्चित करने पर ध्यान केंद्रित करते हैं।</td>
            <td class="tabled">भुगतान एग्रीगेटर्स विभिन्न भुगतान विधियों को संसाधित करने और कई व्यापारियों को भुगतान सेवाएं प्रदान करने के लिए एक एकीकृत मंच प्रदान करने पर ध्यान केंद्रित करते हैं।</td>
           </tr>
           <tr class="tabled">
            <td class="tabled">2.</td>
            <td class="tabled">भुगतान गेटवे के लिए व्यापारियों को अपने व्यापारी खाते रखने और अधिग्रहण करने वाले बैंकों के साथ संबंध स्थापित करने की आवश्यकता होती है।</td>
            <td class="tabled">भुगतान एग्रीगेटर व्यापारियों को एक साझा व्यापारी खाता प्रदान करते हैं और कई व्यापारियों की ओर से अधिग्रहण करने वाले बैंकों के साथ संबंध का प्रबंधन करते हैं।</td>
            </tr>
            <tr class="tabled">
            <td class="tabled">3.</td>
            <td class="tabled">भुगतान गेटवे एन्क्रिप्टेड भुगतान डेटा प्रसारित करते हैं और ग्राहक और व्यापारी के बैंक के बीच सीधे लेनदेन को सत्यापित करते हैं।</td>
            <td class="tabled">भुगतान एग्रीगेटर कई व्यापारियों से भुगतान डेटा एकत्र करते हैं और व्यक्तिगत व्यापारी खातों में धनराशि वितरित करने से पहले उनके व्यापारी पहचान संख्या (एमआईडी) के माध्यम से लेनदेन की प्रक्रिया करते हैं।</td>
            </tr>
            <tr class="tabled">
            <td class="tabled">4.</td>
            <td class="tabled">भुगतान गेटवे अक्सर अधिक अनुकूलन की अनुमति देते हैं, जिससे व्यापारियों को अपनी वेबसाइट या ऐप में भुगतान प्रसंस्करण को सहजता से एकीकृत करने की अनुमति मिलती है।</td>
            <td class="tabled">भुगतान एग्रीगेटर आम तौर पर कम अनुकूलन विकल्पों के साथ मानकीकृत भुगतान प्रसंस्करण समाधान प्रदान करते हैं लेकिन व्यापारियों के लिए तेज़ ऑनबोर्डिंग करते हैं।</td>
            </tr>
           </table>
        </div>
        
        
    </div>

</div>
</div>
<div class="col-md-4 hide-tbl content2 ">
<div class="card crd p-4">
    <div class="row">
        <div class="col-md-12">
            <h5 >
                विषयसूची:
            </h5>

        </div>
        <div class="col-md-12 mt-2">
            
        </div>
        <div class="col-md-12 mt-3">
            <a href="#120">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt=""> &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                            > भुगतान एग्रीगेटर्स</span>
                       
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-3">
            <a href="#121">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt=""> &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='5'}" (click)="color('5')"
                            > मुख्य खिलाड़ी</span>
                       
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-3">
            <a href="#122">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt=""> &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                            >
                            पेमेंट गेटवे/एग्रीगेटर कैसे काम करता है? </span>
                       
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-3">
            <a href="#123">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt=""> &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                            >भुगतान गेटवे और एग्रीगेटर</span>
                       
                    </div>
                </div>
            </a>
        </div>
    </div>
</div>
</div>
<div class="col-md-9 hide ft-9">
    <hr>
    <div class=" row crd">
        <div class="col-md-8">
            <a [routerLink]="['/']">     <button class="btn btn-color" (click)="menues('Payment Gateway')" > <img
                    src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;पेमेंट गेटवे का परिचय
            </button></a>
           
        </div>
        <div class="col-md-4    ">
            <a [routerLink]="['/pay-g']"> <button class="btn btn-color" (click)="menues('PayG')" >पे जी
                &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            
        </div>
    </div>
</div>
</div>
<app-share-button></app-share-button>